import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../auth/auth.service';

export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const permission = route.data?.['permission'];

  if (typeof permission !== 'string') {
    return true;
  }

  return auth.hasPermission(permission) ? true : router.createUrlTree(['/app/access-denied']);
};
